import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Administration} from '../objects/administration';
import {KcPermission} from '../objects/kc-permission';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/authenticate`;
  }

  public getAdministrations(): Observable<Administration[]> {
    return this.httpClient.get<Administration[]>(`${this.endpoint}/administrations`);
  }

  public getPermissions(): Observable<KcPermission[]> {
    return this.httpClient.get<KcPermission[]>(`${this.endpoint}/permissions`);
  }
}
